<landing *ngIf="shouldShowLandingPage$ | async else homepage"></landing>
<ng-template #homepage>
    <homepage></homepage>
</ng-template>
